module.exports = __webpack_public_path__ + "static/media/espiga_integral.5a565c91.png";